export default "__VITE_ASSET__Bw3cGR8R__"